import localeText from "../../../../locale";
import { ADMIN_VERSIONS } from "../../config/adminVersion";
import logo from "../../../images/logo-color-horizontal.png";
import "./AdminVersionChooser.css";

const AdminVersionChooser = ({ onChoose }) => (
  <div className="admin-version-chooser">
    <div className="admin-version-chooser__panel">
      <img className="admin-version-chooser__logo" src={logo} alt="extraconomy" />
      <h1 className="admin-version-chooser__title">{localeText("adminPanelChooseTitle")}</h1>
      <p className="admin-version-chooser__subtitle">{localeText("adminPanelChooseSubtitle")}</p>

      <div className="admin-version-chooser__options">
        <button
          type="button"
          className="admin-version-chooser__option admin-version-chooser__option--primary"
          onClick={() => onChoose(ADMIN_VERSIONS.NEW)}
        >
          <span className="admin-version-chooser__tag">{localeText("adminPanelBeta")}</span>
          <i className="pi pi-star admin-version-chooser__icon" aria-hidden="true" />
          <strong>{localeText("adminPanelNewVersion")}</strong>
          <span>{localeText("adminPanelNewVersionDescription")}</span>
        </button>

        <button
          type="button"
          className="admin-version-chooser__option"
          onClick={() => onChoose(ADMIN_VERSIONS.CLASSIC)}
        >
          <i className="pi pi-history admin-version-chooser__icon" aria-hidden="true" />
          <strong>{localeText("adminPanelClassicVersion")}</strong>
          <span>{localeText("adminPanelClassicVersionDescription")}</span>
        </button>
      </div>

      <p className="admin-version-chooser__hint">{localeText("adminPanelChooseHint")}</p>
    </div>
  </div>
);

export default AdminVersionChooser;
